<template>
<v-sheet color="transparent">
		<h2 class="cn-font grey--text">Mitarbeiter</h2>
		<p class="mt-2">In diesem Bereich legen Sie Personen, die Ihnen bei der Bearbeitung der Reifegraderhebung helfen können, als “Mitarbeiter” an. Sie können beliebig viele Mitarbeiter anlegen. Neu angelegten Mitarbeitern geht damit eine Benachrichtigung mit Anweisungen zur Benutzung dieses Tools zu. </p>
		<v-row>
			<v-col cols="12" md="8">
				<v-list v-for="user in filteredUsers" :key="user.id" class="mt-2 elevation-3">
					<v-list-item>
						<v-list-item-avatar>
						<v-avatar color="grey">
							<v-img  v-if="user.profile_image" :src="user.profile_image"></v-img>
							<v-icon color="white" v-else>mdi-account-circle</v-icon>
						</v-avatar>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title>
								{{ user.display_name }}							
							</v-list-item-title>
							<v-list-item-subtitle>
								<DateNote v-if="user.last_login" name="Last login" :date="user.last_login"></DateNote>
								<span class="caption" v-else>Zuletzt aktiv: Dieser User hat sich bisher noch nicht eingeloggt. </span>
							</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-icon>
							<v-dialog width="400px">
								<template v-slot:activator="{on}">
									<v-btn v-on="on" small fab color="primary2"><v-icon color="white">mdi-arrow-right-bold</v-icon></v-btn>
								</template>
								<DisplayUser :user="user"></DisplayUser>
							</v-dialog>
						</v-list-item-icon>
					</v-list-item>
				</v-list>
			<v-card-actions class="mt-4"> 
				<BackButton></BackButton>
				<v-spacer></v-spacer>
				<v-btn rounded class="elevation-1" color="primary" @click="new_user_dialog = !new_user_dialog">					
					Neuen Mitarbeiter Anlegen
				</v-btn>
			</v-card-actions>
				<v-dialog v-model="new_user_dialog" width="400px">
					<v-card>
						<DialogTitle title="Neuen Kontakt Anlegen" @close="new_user_dialog = false"></DialogTitle>
						<v-card-text>
							<UserForm :doc="new_user_object" @change="(d) => new_user_object = d"></UserForm>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn @click="saveNewContact" color="accent" rounded>Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-col>
			<v-col cols="12" md="4">
			</v-col>
		</v-row>
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import UserForm from "@/components/forms/UserForm"
	import DateNote from "@/components/elements/DateNote"
	import BackButton from "@/components/elements/BackButton"
	import DialogTitle from "@/components/elements/DialogTitle"
	import DisplayUser from "@/components/assessment/users/DisplayUser"
	// import Tile from "@/components/elements/Tile"
	// import - from "@/components/"
	export default {
		name: "People", 
		props: {
			
		},
		data: () => {
			return {
				new_user_dialog: false,
				new_user_object:  {
					first_name: '',
					last_name: '', 
					email: '',
				}
			}
		},
		components: {
			DateNote, 
			UserForm,
			BackButton,
			DialogTitle,
			DisplayUser,
			// Tile
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				users: state => state.users,
			}),
			filteredUsers(){
				return this.users;
			}
		},
		methods: {
			saveNewContact(){
				var user = this.new_user_object;
				user.id = this.generateId();
				user.organisation = [this.user.organisation[0]];
				this.$store.dispatch( "users/addUser", user );
				this.new_user_dialog = false;
			}, 
		}
		// created(){
			
		// }

	}
</script>